export const en = {
    translation: {
        b: {
            cancel: 'Cancel',
            confirm: 'Confirm',
            send: 'Send',
            done: 'Done',
            close: 'Close',
            clear: 'Clear',
            copy_link: 'Copy Link',
            export: 'Export',
            delete: 'Delete',
            delete_confirm: 'Confirm Delete',
            duplicate: 'Duplicate',
            share: 'Share',
            sign_in: 'Sign In',
            sign_up: 'Sign Up',
            email_address: 'Email address',
            yes: 'Yes',
            no: 'No',
        },
        m_languages: {
            title: 'Languages',
            subtitle: 'Choose a language',
        },
        m_feedback: {
            feature: {
                name: 'Feature Request',
                desc: 'Missing a feature you need? Let us know — your ideas matter',
            },
            feedback: {
                name: 'Feedback',
                desc: 'Your feedback means the world to us — drop a quick note',
            },
        },
        m_feedback_t: {
            feature: {
                name: 'Thank you for your suggestion!',
                desc: 'We truly appreciate you taking the time to share your thoughts — it helps us make things better.',
            },
            feedback: {
                name: 'Thank you for your feedback!',
                desc: 'We truly appreciate you taking the time to share your thoughts — it helps us make things better.',
            },
        },
        m_diagram_details: {
            name_place: 'Enter project name',
            desc_place: 'Enter project description',
        },
        m_quick_share: {
            title: 'Share',
            subtitle: '(Query-based link sharing)',
        },
        m_export_img: {
            title: 'Export Image',
        },
        m_export_code: {
            title: 'Export {{db_engine}} Code',
            download_file: 'Download File',
            copy_code: 'Copy Code',
        },
        m_sign_in_remind: {
            title: 'Thanks for trying DB Design',
            subtitle: 'Sign in or sign up to increase table limits, save diagrams, and unlock more features.',
        },
        m_sign_in_restrict: {
            title: 'Sign in to do more in the app',
            subtitle: 'Sign in or sign up to increase table limits, save diagrams, and unlock more features.',
        },
        m_new_diagram: {
            title: 'New Diagram',
            subtitle: 'Choose a database engine',
            open_diagram: 'Open Diagram',
        },
        m_keyboard_shortcuts: {
            title: 'Keyboard Shortcuts',
            ctrl_left: {
                title1: 'Controls',
                title2: '(Left)',
                items: {
                    mouse_sel: 'Mouse select / Hand mode',
                    table: 'Table',
                    line: 'Line',
                    area: 'Area',
                    note: 'Note',
                    comment: 'Comment',
                    pen: 'Pen',
                    undo: 'Undo',
                    redo: 'Redo',
                },
            },
            ctrl_top_left: {
                title1: 'Controls',
                title2: '(Top Left)',
                items: {
                    export_img: 'Export Image',
                    search: 'Search',
                    editor_panel: 'Editor Panel',
                },
            },
            ctrl_bottom_right: {
                title1: 'Controls',
                title2: '(Bottom Right)',
                items: {
                    minimap: 'Minimap',
                    zoom_in: 'Zoom in',
                    zoom_out: 'Zoom out',
                    zoom_100: 'Zoom to 100%',
                },
            },
            ctx_tab: {
                title1: 'Context Menu',
                title2: '(Table)',
                items: {
                    dupl_tab: 'Duplicate table',
                    del_tab: 'Delete table',
                },
            },
            ctx_del_tab: {
                title1: 'Context Menu',
                title2: '(Delete Table)',
                items: {
                    yes: 'Yes',
                    no: 'No',
                },
            },
            ctx_tab_col: {
                title1: 'Context Menu',
                title2: '(Table Column)',
                items: {
                    add_col_below: 'Add new column below',
                    focus_col_above: 'Focus on column above',
                    focus_col_below: 'Focus on column below',
                    move_col_up: 'Move column up',
                    move_col_down: 'Move column down',
                    dupl_col: 'Duplicate column',
                    del_col: 'Delete column',
                },
            },
            ctx_line: {
                title1: 'Context Menu',
                title2: '(Line)',
                items: {
                    del_line: 'Delete line',
                },
            },
            ctx_area: {
                title1: 'Context Menu',
                title2: '(Area)',
                items: {
                    dupl_area: 'Duplicate area',
                    del_area: 'Delete area',
                },
            },
            ctx_multi: {
                title1: 'Context Menu',
                title2: '(Multiselect)',
                items: {
                    select_all: 'Select all elements',
                    create_area_for_select_els: 'Create area for selected elements',
                    dupl_select_els: 'Duplicate selected elements',
                    del_select_els: 'Delete selected elements',
                },
            },
        },
        t: {
            ctrl_left: {
                mouse_select: 'Mouse Selection',
                table: 'Table',
                line: 'Line',
                area: 'Area',
                note: 'Note',
                comment: 'Comment',
                pen: 'Pen',
                undo: 'Undo',
                redo: 'Redo',
            },
            ctrl_top_left: {
                logo: 'Note: This is a playground',
                name: 'Diagram Information',
                editor: 'Editor',
                search: 'Search',
                export: 'Export',
                view_mode: 'View Mode',
                zoom_to_fit: 'Zoom To Fit',
                grid: 'Grid Layout',
            },
            ctrl_top_right: {
                feature_req: 'Feature Request',
                sign_in: 'Sign In',
                quick_share: 'Share',
            },
            ctrl_bottom_right: {
                full_screen: 'Full Screen',
                minimap: 'Minimap',
                zoom_out: 'Zoom Out',
                zoom_100: 'Zoom To 100%',
                zoom_in: 'Zoom In',
                info: 'Information & Resources',
            },
            ctx: {
                base: {
                    colors: {
                        default: 'Default',
                        blue: 'Blue',
                        green: 'Green',
                        red: 'Red',
                        purple: 'Purple',
                        violet: 'Violet',
                    },
                    borders: {
                        none: 'None',
                        solid: 'Solid',
                        dashed: 'Dashed',
                        dotted: 'Dotted',
                    },
                    color: 'Color',
                    border: 'Border',
                    description: 'Description',
                    description_table_place: 'Table description',
                    description_column_place: 'Column description',
                    description_line_place: 'Line description',
                    description_note_place: 'Note description',
                    description_area_place: 'Area description',
                    description_pen_place: 'Pen description',
                    hide_menu: 'Hide Menu',
                    show_menu: 'Show Menu',
                },
                tab_col: {
                    add_col_below: 'Add Column Below',
                    add_col_above: 'Add Column Above',
                    key: 'Key',
                    keys: {
                        none: 'None',
                        pk: 'Primary Key',
                        fk: 'Foreign Key',
                    },
                    index: 'Index',
                    indexes: {
                        none: 'None',
                        regular: 'Regular',
                        unique: 'Unique',
                        full_text: 'Full Text',
                    },
                    increment: 'Auto Increment',
                    enum: 'Enum',
                    enum_place: 'enum1, enum2',
                    not_null: 'Not Null',
                    default_value: 'Default Value',
                    default_value_place: 'default_value',
                    generated_value: 'Generated Value',
                    generated_value_place: 'column * 12',
                    check: 'Check',
                    check_place: 'column >= 3 AND column <= 100',
                    move_col_down: 'Move Column Down',
                    move_col_up: 'Move Column Up',
                    more_functions: 'More Functions'
                },
                line: {
                    change_connects: 'Change Connectors',
                    connects: {
                        empty: 'Empty',
                        one_to: 'One To',
                        many_to: 'Many To',
                        one_null_to: 'One / Null To',
                        many_null_to: 'Many / Null To',
                    },
                    on_update: 'On Update',
                    on_delete: 'On Delete',
                },
                area: {
                    filter: 'Filter Elements',
                },
                multi: {
                    filter: 'Filter Selection',
                    create_area: 'Create Area',
                },
            },
        },
        dropdown_ctrl_view_modes: {
            full: 'Full',
            keys_only: 'Keys Only',
            names_only: 'Names Only',
        },
        dropdown_ctrl_export: {
            export_img: 'Export Image',
            export_code: 'Export SQL Code',
        },
        dropdown_ctrl_settings: {
            sign_in: 'Sign In',
            new_project: 'New Project',
            keyboard_shortcuts: 'Keyboard Shortcuts',
            languages: 'Languages',
        },
        dropdown_ctrl_info_resources: {
            feedback: 'Feedback',
            keyboard_shortcuts: 'Keyboard Shortcuts',
            languages: 'Languages',
            homepage: 'Homepage',
        },
        n: {
            default: 'Loading...',
            file_ready_to_download: 'The file is ready to download',
            code_copied: 'The code has been copied',
            link_copied: 'The link has been copied',
            please_enter_message: 'Please enter a message',
            invalid_email: 'Email is not valid',
            something_wrong_contact: 'Something went wrong. Please try to reload the page or contact us.',
            something_wrong: 'Something went wrong. Please try to reload the page.',
            sending: 'Sending...',
            request_sent: 'Request has been sent. Thank you!',
        },
        pages: {
            not_found: {
                page_not_found: "Page not found.",
                dont_have_access_to_diagram: "You don't have access to this diagram or it may no longer exist.",
                back_home: "Back home"
            },
            error: {
                title: "Error",
                link_is_invalid: "This link is invalid or was entered incorrectly.",
                something_wrong: "Something went wrong.",
                back_to_playground: "Back to Playground",
                please_try_later: "Please try later",
            },
        },
    },
};

export const enMeta = {
    lang_origin: 'English',
    lang_eng: 'English',
    lang_code: 'en',
};
